import { gql } from '../gql';
const routecrumbFragment = gql `
  fragment Routecrumb on Route {
    id
    path
    slug
    parents {
      id
      path
      slug
      object {
        breadcrumbText
      }
    }
  }
`;
const priceFragment = gql `
  fragment Price on Price {
    incVat
    exVat
    vat
  }
`;
const badgeFragment = gql `
  fragment badgeFragment on ProductBadge {
    name
    url
    location
    style
    text
  }
`;
const productPriceFragment = `
    price {
      ${priceFragment}
    }
    previousPrice {
      ${priceFragment}
    }
    recommendedPrice {
      ${priceFragment}
    }
`;
const productMetadataFragment = gql `
  fragment ProductMetadata on Product {
    name
    articleNumber
    description
    primaryRoute {
      path
    }
    ${productPriceFragment}
    images {
      alt
      title
      url
      sizes {
        url
        width
      }
    }
    primaryRoute {
      id
      path
    }
    canonicalCategory {
      name
    }
  }
`;
export const productGridDetailsFragment = gql `
  fragment ProductGridDetails on Product {
    id
    articleNumber
    name
    subName
    shortDescription
    description
    mainHeader
    primaryRoute {
      ${routecrumbFragment}
    }
    ${productPriceFragment}
    images {
      alt
      title
      url
      sizes {
        url
        width
      }
    }
    badges {
      ${badgeFragment}
    }
  }
`;
export const productQuery = (name, fragment) => gql `
  query ${name}($articleNumber: String = null, $id: Int = null) {
    product(articleNumber: $articleNumber, id: $id) {
      id
      ${fragment}
      ${productMetadataFragment}
    }
  }
`;
export const categoryQuery = (name, fragment) => gql `
  query ${name}(
  $id: Int!,
  $first: Paging = 16,
  $offset: Int = 0,
  $filters: FilterInput,
  $orderBy: ProductOrderOptions,
  $orderByDirection: SortDirection
) {
    category(id: $id) {
      id
      ${fragment}
    }
  }
`;
export const routeQuery = (productFragment, categoryFragment, contentFragment) => gql `
  query route(
    $path: String!
    $first: Paging = 16
    $offset: Int = 0,
    $orderBy: ProductOrderOptions,
    $orderByDirection: SortDirection,
    $filters: FilterInput
  ) {
    route(path: $path) {
      ${routecrumbFragment}
      object {
        breadcrumbText
        head {
          title
          metaTags {
            name
            content
          }
        }
        ${categoryFragment}
        ${productFragment}
        ${contentFragment}
        ${productMetadataFragment}
      }
    }
  }
`;
//# sourceMappingURL=deprecatedQueries.js.map